import React from 'react';
import styled from 'styled-components';
import PmwebLogo from '../assets/images/somos-crm.png';
import { MobileWidth, pmBlack } from '../sharedData/Constants';
import GoToSite from '../components/GoToSite';

const Footer = () => {
    return(
        <StyledView>
            <StyleContainer>
                <a rel="noreferrer" target="_blank" href='https://www.pmweb.com.br'>
                    <StyledPmwebLogo src={PmwebLogo} alt="Logo Pmweb" />    
                </a>
                <GoToSite/>	
            </StyleContainer>
        </StyledView>
    );
};

const StyleContainer = styled.div`
    min-width: 1280px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 1107px;
    @media screen and (max-width: ${MobileWidth}){
        min-width: 446px;
    }
    @media screen and (max-width: 509px){
        min-width: 90%;
    }
    @media screen and (max-width: 380px){
        flex-direction: column;
    }
`;

const StyledPmwebLogo = styled.img`
    width: 496px;
    height: 80px;
    @media screen and (max-width: 1191px){
        width: 166px;
        height: 27px;
    }
`;

const StyledView = styled.div`
    background-color: ${pmBlack};
    position: relative;
    z-index: 12;
    height: 172px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: 5px solid white;
`;

export default Footer;